import Vue from "vue";
import router from "../../router"; 

// export async function fetchPosts({ commit }) {
//   try {
//     const { data } = await Vue.axios({
//       url: "/frontend/posts"
//     });
//     commit("setPosts", data);
//   } catch (e) {
//     // console.log("Error para obtener los posts ha finalizado");
//     commit("postsError", e.message);
//   } finally {
//     // console.log("La petición para obtener los posts ha finalizado");
//   }
// }

export async function fetchPost({ commit }, slug) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/posts/${slug}`
    });
    commit("setPost", data);
  } catch (e) {
    router.push({ name: "home" });
  } finally {
    // console.log("La petición para obtener el post ha finalizado");
  }
}

export async function fetchPostVideo({ commit }, slug) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/posts_video/post?slug=${slug}`
    });
    commit("setPost", data);
  } catch (e) {
    commit("postsError", e.message);
  } finally {
    // console.log("La petición para obtener el post ha finalizado");
  }
}

export async function fetchSectionPost({ commit }, id) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/posts/post?id=${id}`
    });
    commit("posts/setPost", data, {
      root: true
    });
  } catch (e) {
    commit("postsError", e.message);
  } finally {
    // console.log("La petición para obtener el Section Post ha finalizado");
  }
}

export async function fetchImportantPosts({ commit }, ln_user) {
  try {
    const { data } = await Vue.axios({
      url: `${process.env.VUE_APP_API_URL}/posts/important_posts?view_as=${ln_user}`,
    });
    commit("posts/setImportantPosts", data, { root: true });
  } catch (e) {
    commit("postsError", e.message);
  } finally {
  }
}

export async function createLike({ commit }, payload) {
  try {
    const { data } = await Vue.axios({
      method: "POST",
      url: `/frontend/posts/${payload.slug}/interactions`,
      data: { interaction_type: payload.type }
    })

    return data
  } catch (e) {

  } finally {}
}

export async function deleteLike({ commit }, payload) {
  const { slug, likeId } = payload

  try {
    const { data } = await Vue.axios({
      method: "DELETE",
      url: `/frontend/posts/${slug}/interactions/${likeId}`
    })

    return data.success
  } catch (e) {

  } finally {}
}

export async function fetchLastMomentSecurity({ commit }, ln_user = null) {
  try {
    const viewAsParam = ln_user ? `?view_as=${ln_user}` : '';
    const { data } = await Vue.axios({
      url: `/frontend/posts/last_moment_security${viewAsParam}`
    });
    commit("setLastMomentSecurity", data);
  } catch (e) {
    commit("postsError", e.message);
  } finally {
    // La petición para obtener el último momento ha finalizado
  }
}
export async function fetchLastPosts({ commit }, ln_user = null) {
  try {
    const viewAsParam = ln_user ? `?view_as=${ln_user}` : '';
    const { data } = await Vue.axios({
      url: `/frontend/posts/last_posts${viewAsParam}`,
    });
    commit("setLastPosts", data);
  } catch (e) {
    commit("postsError", e.message);
  }
}